<template>
  <v-card rounded flat class="pb-2">
    <v-row justify="center" class="purpleContainer">
      <v-card
        min-height="400"
        flat
        color="black"
        class="mb-16 rounded-xxl"
        width="1280"
      >
        <v-card-text>
          <div
            class="white--text sigflo-bodyMedium pa-4"
            v-html="content"
          ></div>
        </v-card-text>
      </v-card>
    </v-row>
  </v-card>
</template>

<script>
  export default {
    name: 'BulkContentCard',
    props: {
      content: String
    },
    data() {
      return {};
    }
  };
</script>

<style scoped></style>
